import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class PoliceBookReportModel extends BaseModel {
  precious_metals= false
  firearms = false

  constructor(data = {}) {
    super();
    this.police_book_date_range = null;
    this.police_book_date_range_date_range = {};
    Object.assign(this, {
      ...data,
      precious_metals: this.precious_metals,
      firearms: this.firearms
    });
  }

  rules = {
    police_book_date_range: 'required',
  };

  attributeHints = {};

  attributeLabels = {
    police_book_date_range: i18n.t('Report Date Range'),
    precious_metals: i18n.t('Only Precious Metals'),
    firearms: i18n.t('Only Firearms'),
  };
}
